import { Suspense } from 'react'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import ErrorMessage from '@components/ErrorBoundary/ErrorMessage'
import ExplorerTreeSkeleton from '@components/skeletons/ExplorerTreeSkeleton/ExplorerTreeSkeleton'
import ExplorerTree from './ExplorerTree'
import type { DataItemPayload } from 'src/types/global'

import './DataExplorer.css'

interface DataExplorerProps {
  selectedId: string | undefined
  onSelect: (item: DataItemPayload) => void
}

export default function DataExplorer({
  selectedId,
  onSelect
}: DataExplorerProps) {
  return (
    <ErrorBoundary errorComponent={ErrorMessage}>
      <Suspense fallback={<ExplorerTreeSkeleton />}>
        <ExplorerTree selectedId={selectedId} onSelect={onSelect} />
      </Suspense>
    </ErrorBoundary>
  )
}
